
define('app/users/registerApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/registerModel',
	'unknown/views/registerView'
], function($, _, Backbone, RegisterModel, RegisterView){
	var initialize = function(){
		var regModel = new RegisterModel();
		var regView = new RegisterView({registerModel: regModel});
		regView.render();
	};
	
	return {
		initialize: initialize
	};
});